<template>
  <div class="mx-14">
    <!--  eslint-disable-next-line vue/no-v-html -->
    <h2 class="font-medium text-[28px] leading-9 mb-14" v-html="titleDoc"></h2>
  </div>
</template>

<script setup lang="ts">
import { useQuestionnaireStore } from '@/questionnaire/stores/questionnaire'
import type { LegalDocumentSection, TemplateVariableValue } from '@/questionnaire/types'
import Handlebars from 'handlebars'
import { computed } from 'vue'

const props = defineProps<{ content: string; templateVariables: LegalDocumentSection['template_variables'] }>()

const questionnaireStore = useQuestionnaireStore()

const titleDoc = computed(() => {
  return Handlebars.compile(props.content)(renderOptionsFor(props.templateVariables.map(({ code }) => code)))
})

const renderOptionsFor = (template_variable_codes: string[]) => {
  const opts: Record<string, TemplateVariableValue> = {}

  for (const key of template_variable_codes) {
    const value = questionnaireStore.getTemplateVariableValue(key)
    const variableKey = questionnaireStore.getTemplateVariableKey(key)
    opts[key] = value
    if (variableKey !== key) {
      opts[variableKey] = !!value
    }
  }

  return opts
}
</script>
